module.exports = __webpack_public_path__ + "assets/b1ba58a0092573c2b5f26723a1f6c649.mp3";